import React from 'react'

class Middleware extends React.Component
{

}

export default Middleware;